import { combineReducers } from "redux";
import { CommonReducer } from "./CommonReducer";

export const reduceres = combineReducers({
  CommonReducer,
});



// WEBPACK FOOTER //
// ./frontend/redux/reducers/index.js